// ログイン・パスワード再設定の要求は, 同じメールアドレスあたりの試行回数に上限があり, 超えると api が 429 を返す.
// api の本文は DRF の既定の文言のため, 表示する文言は front で持つ.
// 上限は登録の有無にかかわらず数えるため, アカウントの状態を表す言い方 (「ロックされました」など) にしない.
export const ATTEMPT_LIMIT_MESSAGE = '試行回数が上限に達しました。しばらく時間をおいてから、もう一度お試しください。'

export const isAttemptLimited = (err) => {
  return err?.response?.status === 429
}
